module.exports = __webpack_public_path__ + "img/orange_102.9a7e3cf5.png";